import { Views } from "../types";

export const Stepper = ({ view, flow }: { view: Views; flow: Views[] }) => {
  const currentViewIndex = flow.indexOf(view);
  return (
    <div className="px-6 pt-4 pb-5  border-b border-alpha-40">
      <p className="text-xs text-content-400 font-medium mb-2">
        Step {currentViewIndex + 1} / {flow.length - 1}
      </p>

      <div className="flex gap-1 items-center">
        {Array(flow.length - 1)
          .fill({})
          .map((_, index) => (
            <div
              key={index}
              className={`w-full h-[2px] rounded ${
                index <= currentViewIndex ? "bg-primary-500" : "bg-alpha-100"
              }`}
            />
          ))}
      </div>
    </div>
  );
};
